import React from 'react';
import { Link } from 'react-router-dom';
import legalContent from '../data/legalContent.json';
import './LegalPage.css';

const renderBlocks = (blocks, keyPrefix) => (
  blocks.map((block, index) => {
    const key = `${keyPrefix}-${index}`;

    switch (block.type) {
      case 'paragraph':
        return <p key={key}>{block.text}</p>;
      case 'labeled':
        return (
          <p key={key}>
            <strong>{block.label}</strong> {block.text}
          </p>
        );
      case 'list':
        return (
          <ul key={key} className="legal-page__list">
            {block.items.map((item, itemIndex) => (
              <li key={`${key}-${itemIndex}`}>
                {item.label && <strong>{item.label} </strong>}
                {item.text}
              </li>
            ))}
          </ul>
        );
      case 'link':
        return (
          <p key={key}>
            <Link to={block.to}>{block.label}</Link>
          </p>
        );
      case 'subsection':
        return (
          <section className="legal-page__subsection" key={key}>
            <h4>{block.heading}</h4>
            {renderBlocks(block.blocks, key)}
          </section>
        );
      default:
        throw new Error(`Unsupported legal content block type: ${block.type}`);
    }
  })
);

const LegalPage = ({ documentType }) => {
  const page = legalContent[documentType];

  if (!page) {
    throw new Error(`Unknown legal document type: ${documentType}`);
  }

  return (
    <div className="legal-page">
      <article className="legal-page__panel" aria-labelledby="legal-page-title">
        <header className="legal-page__header">
          <h1 id="legal-page-title">{page.title}</h1>
          <p>Effective Date: {page.effectiveDate}</p>
        </header>

        <div className="legal-page__document">
          <h2>{page.documentTitle}</h2>
          <p>{page.intro}</p>

          {page.sections.map((section, sectionIndex) => (
            <section className="legal-page__section" key={`${documentType}-${section.heading}`}>
              <h3>{section.heading}</h3>
              {renderBlocks(section.blocks, `${documentType}-${sectionIndex}`)}
            </section>
          ))}

          <p className="legal-page__closing">{page.closing}</p>
        </div>
      </article>
    </div>
  );
};

export default LegalPage;
